import { isArray } from 'lodash';
import { useCallback, useEffect, useRef } from 'react';
export default function useKeyDownListener(callbacks = []) {
    const ref = useRef(null);
    const handleKeyDownListener = useCallback((e) => {
        var _a, _b;
        // The signup dialog owns keyboard focus; underlying forms must not submit or close.
        if (document.querySelector('[data-read-only-notice]'))
            return;
        if (!isArray(callbacks))
            throw new Error('Callbacks argument should array');
        (_b = (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.find((cb) => cb.code === e.code)) === null || _a === void 0 ? void 0 : _a.callback) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [callbacks]);
    useEffect(() => {
        ref.current = handleKeyDownListener;
        window.addEventListener('keydown', ref.current, true);
        return () => {
            if (ref.current)
                window.removeEventListener('keydown', ref.current, true);
            ref.current = null;
        };
    }, [handleKeyDownListener]);
}
